import React, { useCallback, useContext, useEffect, useState } from 'react'
import rest from '../../rest'
import {
  StoreProfileType, PropsStoreContext, StoreContextType, Dominios
} from './types'
import { permissions } from './permissions'

export const initialProfileStore: StoreProfileType = {
  username: '',
  permissions: {
    add_itemtrabalho: [],
    change_itemtrabalho: [],
    delete_itemtrabalho: [],
    view_itemtrabalho: [],
    enviar_itemtrabalho: [],
    concluir_itemtrabalho: [],
    concluir_revisao_reporteandamento: [],
    solicitar_revisao_reporteandamento: [],
    validar_reporteandamento: [],
    enviar_reporteandamento: [],
    view_reporteandamento: [],
    delete_reporteandamento: [],
    change_reporteandamento: [],
    add_reporteandamento: [],
    devolver_reporteandamento: [],
    add_resumo: [],
    change_resumo: [],
    delete_resumo: [],
    view_resumo: [],
    enviar_resumo: [],
    validar_resumo: [],
    solicitar_revisao_resumo: [],
    concluir_revisao_resumo: [],
    add_pauta: [],
    change_pauta: [],
    delete_pauta: [],
    view_pauta: [],
    add_relator: [],
    pode_ser_relator: []
  }
}

const initialDominios: Dominios = {
  departamento: [],
  tipoPauta: [],
  corGrafico: []
}

export const StoreContext = React.createContext<StoreContextType>({} as StoreContextType)

export const StoreProvider = ({ children }: PropsStoreContext) => {
  const getToken = (): string | null => localStorage.getItem('token')
  const getModoApresentacao = (): boolean => JSON.parse(localStorage.getItem('modoApresentacao') || 'false')

  const [token, _setToken] = useState(getToken())
  const [store, _setStore] = useState<StoreProfileType>(initialProfileStore)
  const [init, setInit] = useState(true)
  const [loading, setLoading] = useState(true)
  const [dominios, setDominios] = useState(initialDominios)
  const [modoApresentacao, _setModoApresentacao] = useState(getModoApresentacao())

  const loadPermissions = useCallback(async () => {
    const perms = await rest(`acl/filtros-do-usuario/${permissions.join()}/`)
    const username = localStorage.getItem('username') || ''
    _setStore({...store, username, permissions: perms })
  }, [store])

  useEffect(() => {
    const loadDominios = async () => {
      const departamento = await rest('departamento/')
      const tipoPauta = store.permissions.add_pauta.filter((e: any) => e.area_relatora).length
        ? await rest('tipopauta/')
        : []
      const corGrafico = await rest('corgrafico/')
      setDominios({ departamento, tipoPauta, corGrafico })
    }

    const onInit = async () => {
      try {
        await loadPermissions()
        await loadDominios()
        setLoading(false)
      } catch (e) {
        setLoading(false)
        throw e
      }
    }
    if (init && token) {
      setInit(false)
      onInit()
    }
  }, [init, loadPermissions, store, token])

  const setToken = (userToken: string, username?: string) => {
    if (userToken && username) {
      localStorage.setItem('username', username)
      localStorage.setItem('token', userToken)
    } else {
      localStorage.removeItem("token")
      localStorage.removeItem('username')
      clearStore()
      setInit(true)
      setLoading(true)
    }
    _setToken(userToken)
  }

  const clearStore = () => {
    _setStore(initialProfileStore)
  }

  const getPermission = async (permission: string) => {
    const perm: any[] = await rest(`acl/filtros-do-usuario/${permission}/`)
    return perm
  }

  const setModoApresentacao = (modo: boolean) => {
    localStorage.setItem('modoApresentacao', modo.toString())
    _setModoApresentacao(modo)
  }

  const api = {
    clearStore,
    getPermission,
    setToken,
    setModoApresentacao,
    updatePermissions: loadPermissions
  }

  return <StoreContext.Provider value={{
    store,
    loading,
    dominios,
    modoApresentacao,
    api,
    token
  }}>
    {children}
  </StoreContext.Provider>
}


export function useStore() {
  const context = useContext(StoreContext)
  return context
}
